import { render, staticRenderFns } from "./NewMessagesWidget.vue?vue&type=template&id=bec1a61a&"
import script from "./NewMessagesWidget.vue?vue&type=script&lang=ts&"
export * from "./NewMessagesWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports